var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAlipay && _vm.item.type === 1)?_c('div',{class:['tip-info', ("st-" + (_vm.item.youKuStatus))]},[_vm._v(" "+_vm._s(_vm.getStatusName(_vm.item.youKuStatus))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }